import React from "react";
import { Box } from "@bca/ui-library";

const Grade2SVG: React.FunctionComponent = () => (
  <Box display="flex">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#00C546"/>
      <path
        d="M15.491 15.462V17H8.683v-1.313l3.22-3.452c.323-.36.578-.676.765-.95.187-.278.321-.526.403-.745a1.76 1.76 0 0 0 .13-.636c0-.3-.05-.558-.15-.772a1.12 1.12 0 0 0-.445-.506c-.191-.119-.428-.178-.71-.178-.301 0-.561.073-.78.219a1.392 1.392 0 0 0-.492.608c-.11.26-.164.554-.164.882H8.484c0-.592.142-1.135.424-1.627a3.108 3.108 0 0 1 1.197-1.182c.514-.297 1.125-.445 1.832-.445.697 0 1.285.114 1.763.342.483.223.848.547 1.094.97.25.42.376.921.376 1.505 0 .328-.053.65-.157.964a4.35 4.35 0 0 1-.451.93 7.493 7.493 0 0 1-.698.929c-.273.314-.576.64-.909.978l-1.73 1.94h4.266Z"
        fill="#fff"
      />
    </svg>
  </Box>
);

export default Grade2SVG;
